import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-dialog',
  imports: [CommonModule],
  templateUrl: './lib-dialog.component.html',
  styleUrl: './lib-dialog.component.scss',
})
export class LibDialogComponent implements OnChanges, OnInit {
  @ViewChild('dialog') private dialog?: ElementRef<HTMLDialogElement>;
  /**
   * if true, will display Ok button and Cancel button. If false, will only display a close button
   */
  @Input() hasOkCancelButton = true;
  @Input() hasOkButton = false;
  /**
   * set to true to display the dialog. set to false to close
   */
  @Input() show = false;
  /**
   * the title text to display
   */
  @Input() titleText = 'Edit';
  /**
   * the message to display
   */
  @Input() messageText?: string;
  /**
   * the text for ok-button
   */
  @Input() okText = 'ok';
  /**
   * the text for cancel-button
   */
  @Input() cancelText = 'cancel';
  /**
   * the text for close-button
   */
  @Input() closeText = 'close';
  /**
   * give the css class of the buttons, default "glob-button"
   */
  @Input() buttonClass = 'glob-button';
  @Input() hideCancelCross = false;
  /**
   * the cancel/close button is clicked
   */
  @Output() cancelClicked = new EventEmitter();
  /**
   * the ok button (primary) is clicked
   */
  @Output() okClicked = new EventEmitter();

  public ngOnChanges(changes: SimpleChanges): void {
    if ('show' in changes && !changes['show'].isFirstChange()) {
      if (this.show) {
        this.dialog?.nativeElement.showModal();
      } else {
        this.close();
      }
    }
  }

  protected cancelClick(): void {
    this.cancelClicked.emit();
  }

  protected okClick(): void {
    this.okClicked.emit();
  }

  private close(): void {
    this.dialog?.nativeElement.close();
  }

  ngOnInit(): void {
    this.dialog?.nativeElement.show();
  }
}
